import { render, staticRenderFns } from "./UniversityDetail.vue?vue&type=template&id=fb0a0702&scoped=true"
import script from "./UniversityDetail.vue?vue&type=script&lang=js"
export * from "./UniversityDetail.vue?vue&type=script&lang=js"
import style0 from "./UniversityDetail.vue?vue&type=style&index=0&id=fb0a0702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0a0702",
  null
  
)

export default component.exports